import React from "react";
import styles from "./ModalNotifications.module.scss";
import { useSelector } from "react-redux";
import { dateToString } from "../../utils/util";

import { Modal } from "..";
import { selectNotifications } from "../../store/slices/notifications/slice";

const ModalNotifications = ({ modalRef }) => {
  const { data } = useSelector(selectNotifications);
  return (
    <Modal
      ref={modalRef}
      title="Notifications"
      buttonOkText="CONFIRM"
      showOkButton={false}
      buttonCloseText="CANCEL"
      buttonCloseOnClick={() => modalRef.current.hide()}
      onClose={() => modalRef.current.hide()}
    >
      <div className={styles.notificationsContainer}>
        {!!data.length &&
          data.map((notification, index) => {
            return (
              <div key={index} className={styles.notificationRow}>
                {`${dateToString(new Date(notification.createdAt))} |
                  ${notification.text}`}
              </div>
            );
          })}
      </div>
    </Modal>
  );
};

export default ModalNotifications;
